import { Skeleton, Typography } from "@mui/material";
import { memo } from "react";
import {
  Box,
  ContentRepeater,
  FlexColBox,
} from "../../../../common/components";
import RightSidebar from "../../../../common/components/RightSidebar/RightSidebar";
import { spacing } from "../../../../styles/theme";
import { useThemeBreakpoints } from "../../../../utils/themeUtils";
import ColorSelectSkeleton from "./ColorSelectSkeleton";

const ColorSelectorRightSidebarSkeleton = () => {
  const { isMobile } = useThemeBreakpoints();
  return (
    <RightSidebar>
      <FlexColBox gap={{ xs: "24px", lg: spacing.regularDesktop }}>
        <FlexColBox
          gap={{ xs: spacing.smallMobile, lg: spacing.mediumDesktop }}
        >
          <Typography
            variant={isMobile ? "actionBoldSmallIcon" : "textRegularBold"}
            data-test="studio.rightBar.styleTitle"
          >
            <Skeleton variant="text" width={50} height={16} />
          </Typography>

          <Box
            display={"flex"}
            flexWrap={"wrap"}
            gap={{ xs: spacing.smallMobile, lg: spacing.smallDesktop }}
          >
            <ContentRepeater repeatCount={5}>
              <Skeleton variant="rounded" width={78} height={72} />
            </ContentRepeater>
          </Box>
        </FlexColBox>
        <ColorSelectSkeleton />
      </FlexColBox>
    </RightSidebar>
  );
};

export default memo(ColorSelectorRightSidebarSkeleton);
